import { useState } from 'react';
import { decisionDe } from './decisiones';
import { CLASE_BLOQUEADO } from './EstadoAsambleaAviso';
import styles from './ActivarPreguntaModal.module.css';
import { ultimaDuracion, guardarUltimaDuracion, MAX_MINUTOS } from 'components/TemporizadorVotacion';

const OPCIONES = [0, 1, 2, 3, 5, 10];   // 0 = sin temporizador

// Abrir una votación pasa SIEMPRE por este modal:
//  - F-17 (b), solo sí/no: recuerda con qué regla se decide. Es el segundo control
//    (el primero son las tarjetas al crearla), justo antes de que la gente vote.
//  - Temporizador VISUAL (opcional, solo en este navegador): onAbrir(minutos);
//    0 = sin temporizador. No cierra nada solo: el admin decide.
export default function ActivarPreguntaModal({ pregunta, onCambiar, onAbrir, onClose, abriendo }) {
  const esSiNo = pregunta.question_type === 'yes_no';
  const d = esSiNo ? decisionDe(pregunta.tipo_decision) : null;
  const [minutos, setMinutos] = useState(() => ultimaDuracion());
  const [otro, setOtro]       = useState('');

  const otroNum = otro.trim() === '' ? null : Number(otro);
  const otroValido = otroNum === null || (Number.isInteger(otroNum) && otroNum >= 1 && otroNum <= MAX_MINUTOS);
  const elegidos = otroNum !== null && otroValido ? otroNum : minutos;
  const puedeAbrir = (!esSiNo || !!d) && otroValido && !abriendo;

  const abrir = () => { guardarUltimaDuracion(elegidos); onAbrir(elegidos); };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${styles.modalActivar}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Abrir votación</h3>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <p className={styles.pregunta}>{pregunta.question_text}</p>
          {esSiNo && (d ? (
            <div className={`alert alert-info ${styles.aviso}`}>
              <strong>{d.icono} Decisión {d.titulo.toLowerCase()}</strong> · {d.detalle}.
            </div>
          ) : (
            <div className={`alert alert-warning ${styles.aviso}`}>
              Esta pregunta no tiene tipo de decisión. Pulsa «Cambiar» para elegirlo.
            </div>
          ))}

          <div className={styles.temporizadorTitulo}>
            <i className={`fas fa-stopwatch ${styles.iconoTemporizador}`} />Temporizador (solo para ver)
          </div>
          <div className={styles.opciones}>
            {OPCIONES.map(m => {
              const activa = otroNum === null && minutos === m;
              return (
                <button key={m} type="button" aria-pressed={activa}
                  className={`btn btn-sm ${activa ? 'btn-primary' : 'btn-secondary'}`}
                  onClick={() => { setMinutos(m); setOtro(''); }}>
                  {m === 0 ? 'Sin temporizador' : `${m} min`}
                </button>
              );
            })}
            <input type="number" inputMode="numeric" min={1} max={MAX_MINUTOS} placeholder="Otro (min)"
              value={otro} onChange={e => setOtro(e.target.value)} aria-label="Otro tiempo en minutos"
              aria-invalid={!otroValido}
              className={otroValido ? styles.otro : styles.otroInvalido} />
          </div>
          {!otroValido && (
            <div className={styles.otroError}>Escribe un número entero de 1 a {MAX_MINUTOS} minutos.</div>
          )}
          <div className={styles.ayuda}>
            Es solo un aviso: al terminar el tiempo no se cierra nada, tú decides si cierras la votación o das más tiempo.
          </div>
        </div>
        <div className="modal-footer">
          {esSiNo && <button type="button" className="btn btn-secondary" onClick={onCambiar}>Cambiar</button>}
          <button type="button" className={`btn btn-primary ${!puedeAbrir ? CLASE_BLOQUEADO : ''}`} onClick={abrir} disabled={!puedeAbrir}>
            <i className="fas fa-play" /> {abriendo ? 'Abriendo…' : 'Abrir votación'}
          </button>
        </div>
      </div>
    </div>
  );
}
